export class ResourceCenterStrings {
  static get contentTypesKeyName() {
    return "content-types";
  }

  static get languageKeyName() {
    return "language";
  }

  static get industriesKeyName() {
    return "industries";
  }

  static get solutionsKeyName() {
    return "solutions";
  }

  static get categoriesKeyName() {
    return "categories";
  }

  static get productsKeyName() {
    return "products";
  }

  static get searchtextKeyName() {
    return "searchtext";
  }

  static get pageKeyName() {
    return "page";
  }
}
